import styled from "styled-components";

import { theme } from "../../config/theme";

const styles = {
  healthWrapper: {
    display: "flex",
    flexDirection: "column",
    width: "100%"
  },
  cardsContainer: {
    marginTop: "28px",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between"
  },
  card: {
    margin: "4px 0",
    width: "32%",
    minWidth: "280px",
    minHeight: "180px"
  },
  cardContent: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end"
  },
  cardTitle: {
    fontSize: "12px",
    fontWeight: "600",
    marginBottom: "28px"
  },
  cardText: {
    fontSize: "14px",
    color: theme.palette.primary.darkGray,
    paddingRight: "46px",
    marginLeft: "12px"
  },
  cardValue: {
    fontSize: "55px",
    marginRight: "8px",
    fontWeight: "200"
  },
  healthContainer: {
    width: "100%"
  },
  primaryHeading: {
    color: theme.palette.primary.black,
    fontSize: "16px",
    fontWeight: "600"
  },
  itemWrapper: {
    display: "flex"
  },
  nameWrapper: {
    paddingLeft: 4
  },
  cardWrapper: {
    width: 300,
    padding: "20px 0"
  },
  headerWrapper: {
    padding: "10px 0",
    margin: "0 0 10px 0",
    borderBottom: `1px solid ${theme.palette.primary.gray}`
  },
  healthCheckIcon: {
    height: "20px",
    marginRight: "12px"
  },
  high: {
    fill: `${theme.palette.health.green}`
  },
  medium: {
    fill: `${theme.palette.health.orange}`
  },
  low: {
    fill: `${theme.palette.health.yellow}`
  },
  percent: {
    position: "absolute ",
    right: 100,
    top: 22,
    display: "flex "
  }
};

const PillContainer = styled.div`
  position: relative;
  min-width: 132px;
`;

const PillDate = styled.div`
  font-size: 12px;
  color: ${theme.palette.primary.black};
  padding: 0 10px;
  margin: 0 10px 8px 0;
  border-radius: 3px;
  cursor: pointer;
  background: ${theme.palette.primary.white};
  border: 1px solid ${theme.palette.primary.gray};
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 35px;

  svg {
    width: 15px;
    opacity: 0.5;
    margin-right: 5px;
    margin-top: -2px;
  }
`;

const FilterRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const PanelWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;

export { FilterRow, PillDate, PillContainer, PanelWrapper, styles };
